import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const IDNumber = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.idNumber`}
      control={control}
      render={({ field }) => <FF2 label="ID Number" field={field} input={(props) => <TextInput {...props} />} />}
    />
  )
}
